export default __webpack_public_path__ + "static/media/statistics_2017_English.0c54f0ae.zip";